import React from 'react';
import styled from "styled-components";
import ConciliateTransactionsModal from "./ConciliateTransactionsButton.react";
import {Dropdown, Icon, Navbar} from "react-materialize";
import SideNavLinks from "./SideNavLinks.react";
import ConciliateTransactionsButton from "./ConciliateTransactionsButton.react";

const StyledSideNav = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 6.5rem;
  
  .user-name {
    font-size: 2.2rem;
    i {
     height: 6.5rem;
     font-size: 41px;
    }
  }
`

const SideNavItems = ({userName, permissions}) => {
  return (
    <StyledSideNav>
      <ConciliateTransactionsButton />
      <Dropdown
        id="NavDropdown"
        options={{
          alignment: 'left',
          autoTrigger: true,
          closeOnClick: true,
          constrainWidth: true,
          container: null,
          coverTrigger: true,
          hover: false,
          inDuration: 150,
          onCloseEnd: null,
          onCloseStart: null,
          onOpenEnd: null,
          onOpenStart: null,
          outDuration: 250
        }}
        trigger={<a className={'user-name'} href="#!">{userName}<Icon right>arrow_drop_down</Icon></a>}
      >
        <SideNavLinks permissions={permissions} />
      </Dropdown>
    </StyledSideNav>
  )
}

export default SideNavItems;
